export default class debug {
  static log (...args) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(...args)
    }
  }

  static assert (condition, message = '', includeStack = !message, breakOnFail = false) {
    if (process.env.NODE_ENV !== 'production') {
      if (!condition) {
        const stack = includeStack ? '\n' + (new Error()).stack.split('\n').slice(2).join('\n') : ''
        debug.log((message || `ASSERTION FAILURE (${condition})`) + stack)
        if (breakOnFail) {
          debug.break()
        }
      }
    }
  }

  static break () {
    if (process.env.NODE_ENV !== 'production') {
     debugger // eslint-disable-line no-debugger
    }
  }

  static async pause (seconds) {
    if (process.env.NODE_ENV !== 'production') {
      await snooze(seconds * 1000)
    }
  }
}

const snooze = ms => new Promise(resolve => setTimeout(resolve, ms))
